import Vue from 'vue';
import App from './App.vue';

import makeStore from './store';

import { clearFilters, initApp, search, setCurrentPage, setSearchQuery } from './store/actions';
import { IState } from './store/state';

import VueRouter from 'vue-router';
const VueScrollTo = require('vue-scrollto');

Vue.use(VueRouter);

Vue.use(VueScrollTo, { 
	duration: 100,
})

Vue.config.productionTip = false;
export const router = new VueRouter({
	mode: 'history',
	routes: [
	  { path: '/'},
	]
  });

const createApp = (element: Element, data: IState) => {
	const store = makeStore(); // Make a new store for each instance.


	const instance = new Vue({
		store,
		router,
		created() {
			this.$store.dispatch(initApp(data));
			router.beforeEach((to, from, next) => {
				next();
			});
		},
		render: h => h(App)
	}).$mount(element);

	return instance;
};

if (process.env.NODE_ENV === 'production') {
	(window as any).svhiqbcd11bced5814128bf21464ea852691a = (window as any).svhiqbcd11bced5814128bf21464ea852691a || createApp;
} else {
	const appElement = document.querySelector('#app');
	if(appElement) {
		const mock = require('./mock-state').default;
		createApp(appElement, mock);
	}
}
